import React from "react";

export const SkillBar = ({ label, years, percent, color, c, isDark }) => (
  <div style={{ marginBottom: 8 }}>
    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
      <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 12, color: c.onSurfaceVariant, textTransform: "uppercase", letterSpacing: "0.05em" }}>
        {label}
      </span>
      <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 12, color }}>
        {years}
      </span>
    </div>
    <div style={{ height: 4, background: isDark ? c.surfaceContainerHighest : "#dde2f9", borderRadius: 999, overflow: "hidden" }}>
      <div className="skill-bar" style={{ height: "100%", background: `linear-gradient(90deg, ${color}, ${c.secondary})`, width: `${percent}%`, borderRadius: 999 }} />
    </div>
  </div>
);